import React from "react";
import Menu from "antd/lib/menu";
import { TMenu, TItem } from "./interface";
import ZIcon from "@atoms/ZIcon";

import "./index.less";

const Item: TItem = ({
	children,
	className = "",
	iconName = "",
	iconPlacement = "left",
	allowOverflow = false,
	...rest
}) => (
	<Menu.Item
		icon={
			iconName ? (
				<ZIcon
					name={iconName}
					size="sm"
					className={
						iconPlacement === "left" ? "ml-0 mr-2" : "ml-2 mr-0"
					}
				/>
			) : null
		}
		className={`z-menu-item px-4 ${
			iconPlacement === "right" ? "z-menu-item-icon-right" : ""
		} ${
			allowOverflow ? "" : "overflow-ellipsis overflow-hidden"
		} ${className}`}
		{...rest}
	>
		{children}
	</Menu.Item>
);
const ZMenu: TMenu = ({
	children,
	disableOverflow,
	className = "",
	...rest
}) => (
	<Menu
		className={`z-menu ${className} ${
			disableOverflow ? " disable-overflow " : ""
		}`}
		{...rest}
	>
		{children}
	</Menu>
);

ZMenu.Item = Item;
ZMenu.ItemGroup = Menu.ItemGroup;
ZMenu.SubMenu = Menu.SubMenu;

export default ZMenu;
